import {
  AspectRatio,
  Box,
  Button,
  Flex,
  GridItem,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { AuthContext } from "~/App";
import { BlueButton } from "../Buttons";
import { AdminPreviewFragment } from "../fragments.generated";
import { useRemoveAdministratorMutation } from "./index.generated";

export const AdminIcon = ({ admin }: { admin: AdminPreviewFragment }) => {
  const { currentAdminId } = useContext(AuthContext);

  return (
    <GridItem w="100%" position="relative" overflow={"hidden"}>
      <AspectRatio ratio={1}>
        <Box justifyContent={"center"} border="1px" borderColor="white">
          <AiOutlineUser color="white" size="60%" />
        </Box>
      </AspectRatio>
      <Flex justifyContent={"space-between"}>
        <AdminNamePreveiew admin={admin} />
        {currentAdminId !== admin.id ? <AdminMenu admin={admin} /> : null}
      </Flex>
    </GridItem>
  );
};

const AdminNamePreveiew = ({ admin }: { admin: AdminPreviewFragment }) => {
  const previewName =
    admin.name.length > 13 ? admin.name.substring(0, 12) + "..." : admin.name;

  return (
    <Text
      color="white"
      fontWeight="bold"
      fontSize={15}
      mt={2}
      whiteSpace={"nowrap"}
    >
      {previewName}
    </Text>
  );
};

const AdminMenu = ({ admin }: { admin: AdminPreviewFragment }) => {
  return (
    <Menu>
      <MenuButton
        mt={1}
        as={IconButton}
        bgColor="#16181a"
        _hover={{ bgColor: "#16181a" }}
        _active={{ bgColor: "#16181a" }}
      >
        <BsThreeDotsVertical color="white" size={20} />
      </MenuButton>
      <MenuList>
        <RemoveAdminMenu admin={admin} />
      </MenuList>
    </Menu>
  );
};

const RemoveAdminMenu = ({ admin }: { admin: AdminPreviewFragment }) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [removeAdminRes, removeAdmin] = useRemoveAdministratorMutation();

  useEffect(() => {
    if (removeAdminRes.data?.removeAdministrator.error) {
      toast({
        title: "管理者の削除に失敗しました。",
        description: removeAdminRes.data?.removeAdministrator.error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
    if (removeAdminRes.data?.removeAdministrator.administrator) {
      toast({
        title: "管理者の削除に成功しました。",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [removeAdminRes.data]);

  return (
    <>
      <MenuItem onClick={onOpen}>管理者の削除</MenuItem>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>管理者の削除</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>以下の管理者を削除します。本当によろしいですか？</Text>
            <Text>管理者名：{admin.name}</Text>
          </ModalBody>

          <ModalFooter>
            <Flex>
              <BlueButton
                label={"削除"}
                onClick={() => {
                  removeAdmin({
                    input: { id: admin.id },
                  });
                  onClose();
                }}
              />
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
